import { __read } from "tslib";
import React, { useEffect, useState } from 'react';
export var QuantityInput = function (props) {
    var quantity = props.quantity, available = props.available, itemId = props.itemId, blocked = props.blocked, idx = props.idx, handleKeyDown = props.handleKeyDown, handleOnFocus = props.handleOnFocus, handeClick = props.handeClick, soldOut = props.soldOut, layout = props.layout, _a = props.stockDisplay, stockDisplay = _a === void 0 ? 'dots' : _a;
    var isOverlay = layout === 'overlay';
    var _b = __read(useState(quantity), 2), value = _b[0], setValue = _b[1];
    useEffect(function () {
        setValue(quantity);
    }, [quantity]);
    var handleChange = function (event) {
        if (Number(event.target.value) || event.target.value === '' || !event.target.value || +event.target.value === 0) {
            var quantity_1 = event.target.value > available ? available : event.target.value;
            props.updateChanges(itemId, quantity_1);
            setValue(quantity_1);
        }
    };
    var convertAvailable = function (available, quantity) {
        var availability = 0;
        var realAvailable = +available;
        if (realAvailable > 0) {
            availability = realAvailable - +quantity;
        }
        return availability;
    };
    var showAvailable = function () {
        if (available === 9999) {
            return (React.createElement("span", { className: "quantity-grid__availability" },
                React.createElement("div", { className: "infiniteAvailability" })));
        }
        var remaining = convertAvailable(available, value);
        if (stockDisplay === 'numbers') {
            if (!blocked && !soldOut && remaining > -1) {
                return (React.createElement("span", { className: "quantity-grid__availability" },
                    "(",
                    remaining,
                    ")"));
            }
            return null;
        }
        return React.createElement(React.Fragment, null,
            !blocked && !soldOut && remaining > -1 && remaining < 6 &&
                React.createElement("span", { className: "quantity-grid__availability" },
                    "(",
                    remaining,
                    ")",
                    React.createElement("div", { className: "lowAvailability" })),
            !blocked && !soldOut && remaining > 5 && remaining < 16 &&
                React.createElement("span", { className: "quantity-grid__availability" },
                    React.createElement("div", { className: "mediumAvailability" })),
            !blocked && !soldOut && remaining > 15 &&
                React.createElement("span", { className: "quantity-grid__availability" },
                    React.createElement("div", { className: "infiniteAvailability" })));
    };
    var renderStatusBadge = function (label, modifier) { return (React.createElement("span", { className: "quantity-input__badge quantity-input__badge--".concat(modifier) }, label)); };
    var renderInput = function () {
        var inputEl = !blocked && !soldOut ? (React.createElement("input", { className: "quantity-input__input", type: "text", id: 'size_' + itemId, name: 'size_' + itemId, value: value, onChange: handleChange, onKeyDown: handleKeyDown, onFocus: handleOnFocus, onClick: handeClick })) : null;
        if (isOverlay) {
            return (React.createElement(React.Fragment, null,
                inputEl,
                showAvailable(),
                blocked && renderStatusBadge('BLOCKED', 'blocked'),
                soldOut && !blocked && renderStatusBadge('SOLD OUT', 'sold-out')));
        }
        return (React.createElement(React.Fragment, null,
            inputEl,
            showAvailable(),
            blocked && React.createElement("span", { className: "quantity-input__label" }, "Blocked"),
            soldOut && !blocked && React.createElement("span", { className: "quantity-input__label" }, "Sold Out")));
    };
    if (props.regularDiv) {
        return (React.createElement("div", { className: "quantity-grid__cell quantity-grid__item" }, renderInput()));
    }
    return (React.createElement("td", { className: "quantity-grid__cell quantity-grid__item", tabIndex: idx }, renderInput()));
};
//# sourceMappingURL=QuantityInput.js.map